import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'au-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.scss'],
})
export class PublicFooterComponent implements OnInit {
  mercuryLogoPath = '../../assets/images/logos/logo.png';
  currentYear!: number;

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
  }
}
